import React from "react";
import "./Projects.css";
import { FaReact, FaHardHat } from "react-icons/fa";
import {
  SiBlockchaindotcom,
  SiHtml5,
  SiChai,
  SiEthereum,
  SiExpress,
  SiSocketdotio,
  SiTailwindcss,
  SiReactrouter,
  SiJavascript,
  SiMongodb,
  SiPrisma,
  SiGoogleauthenticator,
  SiNodedotjs,
  SiRazorpay,
  SiRedux
} from "react-icons/si";
import { RiNextjsFill,RiFirebaseFill } from "react-icons/ri";
import { FaCcStripe,FaSass } from "react-icons/fa6";
import { DiCss3 } from "react-icons/di";
import { VscJson } from "react-icons/vsc";
import { IoLogoJavascript } from "react-icons/io";

const data=[{skillsIcons:[<RiNextjsFill/>,<RiFirebaseFill/>]}]
export const Projects = () => {
  return (
    <>
      <div className="section projectsection">
        <h2 className="section__title different">Projects</h2>
        <div className="allProjects">





        {/* data-aos="fade-right" */}
            <div className="projects_container"  >
              <div className="project" >
              <div className="project_videocontainer">
                <div>
                  <img
                    src="https://firebasestorage.googleapis.com/v0/b/newsapp-c250b.appspot.com/o/ProjectImages%2FFreeLancer.png?alt=media&token=48370b7f-b5dd-405b-be31-78b2f3b1fcfc"
                    alt="FreeLancer Web Application"
                  />
                </div>
              </div>
              <div className="project_information">
                <h2>FreeLancer.</h2>
                <p >
                  A Full stack web application that connects Freelancers to their potential clients.
                  The website is secured through jwt authentication with role based authorization to respective Sellers' or Clients' dashboards.
                  <br/>
                  Features include:
                  Chat support,
                  Payment Integration using Stripe,
                  Order Confirmation Section,
                  Dedicated profile section to showcase skills, projects & achievements
                  along with customer rating and comment section.
                </p>
                <div >
                  <SiMongodb />
                  <SiExpress />
                  <FaReact />
                  <SiNodedotjs />
                  <FaCcStripe/>
                </div>
                <div>
                  <a
                    href="https://freelancerwebapp.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      See this Live
                    </span>
                  </a>
                  <a
                    href="https://github.com/SuvranilG/FreeLancerWebApp/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>


          <div className="projects_container"  >
            <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img
                    src="https://firebasestorage.googleapis.com/v0/b/newsapp-c250b.appspot.com/o/ProjectImages%2FHeadlines.png?alt=media&token=bcde156c-57e2-4725-b72f-6e77da3a91b5"
                    alt="Headlines"
                  />
                </div>
              </div>
              <div className="project_information">
                <h2>Headlines</h2>
                <p>
                  A NextJs based news publishing fullstack web project with social logins and session management using Authjs. 
                  Prisma ORM for connecting backend to mongoDB and utilised Firebase's storage service. 
                  Role based user access enabling only admins to publish authentic news articles. <br/>Users need to be 
                  logged in to comment on posts or read full article. Fully paginated response along with most popular section news from various categories based on the view counts on the respective posts.

                </p>
                <div>
                  
                  <FaSass/>
                  {/* <IoLogoJavascript /> */}
                  <RiNextjsFill/>
                  <SiGoogleauthenticator/>
                  <SiMongodb/>
                  <SiPrisma/>
                  <RiFirebaseFill/>

                </div>
                <div>
                  <a
                    href="https://headlinesnews.vercel.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      See this Live
                    </span>
                  </a>
                  <a
                    href="https://github.com/SuvranilG/NewsWebApp"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
            
            
            <div className="projects_container"  >
              <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img src="https://firebasestorage.googleapis.com/v0/b/newsapp-c250b.appspot.com/o/ProjectImages%2FCodex.png?alt=media&token=ab20ff8f-bff8-4e78-a8df-5fb5fd71eb5b" alt="Codex" />
                </div>
              </div>
              <div className="project_information">
                <h2>Codex Solutions</h2>
                <p>
                  Codex is a real-time code collaboration platform that supports multiple clients 
                  to connect to specific rooms and contribute their code into the code editor that syncs
                  across all the connected members in the room using socket.io at the server end. <br />
                  It also supports multiple programming languages to compile and fetch output using api response. 
                </p>
                <div>
                  <FaReact/>
                  <SiNodedotjs />
                  <SiExpress />
                  <SiSocketdotio />
                </div>
                <div>
                  <a
                    href="https://codexwebapp.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      See this Live
                    </span>
                  </a>
                  <a
                    href="https://github.com/SuvranilG/CodexWebApp/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>

        <div className="projects_container" >
          <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img
                    src="https://firebasestorage.googleapis.com/v0/b/newsapp-c250b.appspot.com/o/ProjectImages%2FWebFlix.png?alt=media&token=67e0a7ba-05ed-4f10-8e73-33e9e5c3cab0"
                    alt="WebFlix"
                  />
                </div>
              </div>
              <div className="project_information">
                <h2>WebFlix</h2>
                <p>
                  A Netflix inspired UI clone project that fetches real time Movies and TV shows collection 
                  from TMDB's free api and displaying it with the help of React and Sass library on the frontend
                  making it super interactive web app with full of loading animations and sleek & modern UI .
                </p>
                <div>
                  <FaSass />
                  <FaReact />
                  <SiRedux/>
                  <VscJson />
                </div>
                <div>
                  <a
                    href="https://webflix-url.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      Live Demo
                    </span>
                  </a>
                  {/* <a
                    href="https://github.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      View Code
                    </span>
                  </a> */}
                </div>
              </div>
            </div>
          </div>
            
            
        <div className="projects_container" >
              <div className="project">
              <div className="project_videocontainer">
                <div>
                  <img
                    src="https://firebasestorage.googleapis.com/v0/b/newsapp-c250b.appspot.com/o/ProjectImages%2FOgreenery.png?alt=media&token=18ef89c8-b1c7-4ecd-989e-8ade19eced4a"
                    alt="Travel App"
                  />
                </div>
              </div>
              <div className="project_information">
                <h2>O'greenery</h2>
                <p>
                  O'greenery is a full stack travel app to discover places available for staycation.
                  Fully secured login and sign up using jwt authentication and authorization of user credentials.
                  Advaned filtered seach as per facilities available and booking & payment integration using Razorpay's 
                  payment gateway.
                </p>
                <div>
                  <SiNodedotjs />
                  <SiExpress />
                  <SiMongodb />
                  <FaReact/>
                  <SiReactrouter/>
                  <SiRazorpay/>
                  
                </div>
                <div>
                  <a
                    href="https://ogreenery.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt onbt">
                      See this Live
                    </span>
                  </a>
                  <a
                    href="https://github.com/SuvranilG/TravelAppFrontEnd"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      Frontend
                    </span>
                  </a>
                  <a
                    href="https://github.com/SuvranilG/FreeLancerWebAppBackendForVercel"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span type="button" className="btns onbt">
                      Backend
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </>
  );
};
